import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import DataTable from "react-data-table-component";
import EditDetailPopup from "../Popup/editDetailPopup";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import { useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import DeleteUserPopup from "../Popup/deleteUserPopup";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      padding: "15px",
      opacity: "1",
      textAlign: "center",
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5) !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
      "&:nth-child(2n)": {
        backgroundColor: "rgba(249, 249, 249, 0.6) !important",
      },
      textAlign: "center",
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const TableList = ({ searchItem, userList, setUserList, getUserList }) => {
  const [openEditDetailPopup, setOpenEditDetailPopup] = useState(false);
  const HandleRemovePopUp = () => setOpenEditDetailPopup(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const HandleDeleteRemovePopUp = () => setDeletePopup(false);

  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    getUserList();
  }, []);

  const memoizedUserList = useMemo(() => userList, [userList]);

  const filteredOrders = React.useMemo(() => {
    const userData = [...memoizedUserList];
    return userData.filter((user) => {
      const searchTerm = searchItem.toLowerCase();
      return (
        user?.uid?.toLowerCase().includes(searchTerm) ||
        user?.userLastName?.toLowerCase().includes(searchTerm) ||
        user?.userFirstName?.toLowerCase().includes(searchTerm) ||
        user?.roleName?.toLowerCase().includes(searchTerm) ||
        user?.userEmail?.toLowerCase().includes(searchTerm)
      );
    });
  }, [memoizedUserList, searchItem]);

  const columns = [
    {
      name: "User Id",
      selector: (row) => row?.uid,
      sortable: true,
      sortFunction: (a, b) => a.uid.localeCompare(b.uid),
    },
    {
      name: "First Name",
      selector: (row) => row?.userFirstName,
      sortable: true,
      sortFunction: (a, b) => a.userFirstName.localeCompare(b.userFirstName),
    },
    {
      name: "Last Name",
      selector: (row) => row?.userLastName,
      sortable: true,
      sortFunction: (a, b) => a.userLastName.localeCompare(b.userLastName),
    },
    {
      name: "Email",
      selector: (row) => row?.userEmail,
      sortable: true,
      sortFunction: (a, b) => a.userEmail.localeCompare(b.userEmail),
    },
    {
      name: "Role",
      selector: (row) => row?.roleName,
      sortable: true,
      sortFunction: (a, b) => a.roleName.localeCompare(b.roleName),
    },
    {
      name: "Vorschau",
      className: "w-40 px-5",
      selector: (row) => row.actions,
      sortable: false,
      cell: (row) => (
        <div className="flex items-center gap-4">
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-0 -top-7  px-2 py-1 text-lg bg-blue rounded text-blue-400 w-auto whitespace-nowrap after:content-[' '] after:-bottom-2 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular max-w-fit"
                style={{}}
              >
                Bearbeiten
              </p>
            }
          >
            <button
              onClick={() => {
                setOpenEditDetailPopup(true);
                setSelectedUser(row);
              }}
              // onClick={() => {
              //   setOpenEditDetailPopup(true);
              //   setSelectedUser(row);
              // }}
              className="rounded-lg p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] transition-all ease-in focus:border-blue-600"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/edit_square.svg" width="20px" height="20px" />
            </button>
          </Popover>
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-2 -top-7 text-blue-400 px-2 py-1 text-lg bg-red rounded w-auto whitespace-nowrap after:content-[' '] after:-bottom-2 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-red shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular max-w-fit"
                style={{}}
              >
                Delete
              </p>
            }
          >
            <button
              onClick={() => {
                setDeletePopup(true);
                setSelectedUser(row);
              }}
              className="rounded-lg p-[10px] my-1 border border-transparent shadow-[0_0_4px_rgba(253,37,30,0.3)] hover:border-[rgba(238,18,10,0.5)] transition-all ease-in focus:border-[rgba(238,18,10,0.5)]"
              style={{
                backgroundColor: "rgba(238, 18, 10, 0.05)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <RiDeleteBin6Line className="text-[#EE120A] " />
            </button>
          </Popover>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div>
      <DataTable
        noDataComponent={
          <div className="py-4 text-gray-500">
            Es sind keine Datensätze zum Anzeigen vorhanden
          </div>
        }
        className="mt-6 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
        scrollable
        scrollHeight="590px"
        fixedHeader
        columns={columns}
        data={filteredOrders || []}
        pagination={false}
        customStyles={customStyles}
        sortIcon={<SortIcon />}
        highlightOnHover
      />

      <EditDetailPopup
        userList={filteredOrders}
        getUserList={getUserList}
        user={selectedUser}
        setUser={setSelectedUser}
        openPopUp={openEditDetailPopup}
        closePopUp={HandleRemovePopUp}
      />
      <DeleteUserPopup
        user={selectedUser}
        userList={userList}
        setUserList={setUserList}
        getUserList={getUserList}
        openPopUp={deletePopup}
        closePopUp={HandleDeleteRemovePopUp}
      />
    </div>
  );
};

export default TableList;
